import { ReactNode } from "react";
import { cx } from "utils";

/**
 * Table shell: bordered, rounded card wrapper with horizontal scroll and the
 * <table> element. Compose with TableHeader / TableBody, or use DataTable.
 */
export const Table = ({ children, className }: { children: ReactNode; className?: string }) => (
  <div className="border border-gray-200 rounded-lg bg-white overflow-hidden">
    <div className="overflow-x-auto">
      <table className={cx("w-full border-collapse", className)}>{children}</table>
    </div>
  </div>
);

export default Table;
